import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { resolveImage } from "@/lib/api";
import EnquiryForm from "./EnquiryForm";

export default function EnquiryDialog({ open, onClose, yacht, brandName }) {
  if (!yacht) return null;
  const interest = `${brandName} — ${yacht.name}`;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto rounded-none border-navy-ink/10 bg-navy p-0 sm:max-w-3xl" data-testid="enquiry-dialog">
        <div className="grid md:grid-cols-12">
          <div className="relative hidden md:col-span-5 md:block">
            <img src={resolveImage(yacht.image)} alt={yacht.name} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <p className="text-[10px] uppercase tracking-[0.35em] text-gold-pale">{brandName}</p>
              <p className="mt-1 font-serif text-3xl font-light text-white">{yacht.name}</p>
            </div>
          </div>
          <div className="p-8 md:col-span-7 lg:p-10">
            <DialogHeader className="text-left">
              <p className="text-[10px] uppercase tracking-[0.45em] text-gold">Private Enquiry</p>
              <DialogTitle className="font-serif text-3xl font-light leading-tight text-navy-ink" data-testid="enquiry-dialog-title">
                {yacht.name}
              </DialogTitle>
              <DialogDescription className="text-xs font-light text-mist">
                Share a few details and our private office will arrange a personal introduction to the {brandName} {yacht.name}.
              </DialogDescription>
            </DialogHeader>
            <div className="mt-8">
              <EnquiryForm presetInterest={interest} onSuccess={onClose} prefix="enquiry-dialog" submitLabel="Send Enquiry" />
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
